import React, {useState, useEffect} from 'react';
import axios from 'axios';
import ChartistGraph from "react-chartist";
import ChartistTooltip from "chartist-plugin-tooltips-updated";
import {
  Button,
  Card ,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import {useLocalStorage} from 'react-use';

const SORT_FIELD_MAP = {};

export default function Report() {

  const COLOR = {
    0: `text-success`,
    1: `text-danger`,
    2: `text-warning`,
    3: `text-primary`
  };

  const BAR_COLOR = {
    0: `stroke-success`,
    1: `stroke-danger`,
    2: `stroke-warning`,
    3: `stroke-primary`
  };

  const [auth] = useLocalStorage('authenticated');
  const [params, setParams] = useState({});
  const [instruments, setInstruments] = useState([]);
  const [years, setYears] = useState([]);
  const [auditees, setAuditees] = useState([]);
  const [report, setReport] = useState(null);

  const fetchReport = async () => {
    if(Object.keys(params).length == 0){
      return console.log('');
    }
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}report/instrument`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: params,
      }
    );
    if (response.data.legends[3] == 'NA'){
      response.data.legends = ['OK', 'OB', 'KTS']
    }
    setReport(response.data);
  }

  const fetchInstruments = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}instruments`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {all: true},
      }
    );

    setInstruments(response.data.items);
  }

  const fetchYears = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}schedules`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          INSTRUMENT_ID: params.INSTRUMENT_ID,
          expand: `year`,
          fields: `year`,
          all: `true`
        },
      }
    );

    setYears([...new Set(response.data.items.map(item => item.year))]);
  }

  const fetchAuditees = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}schedules`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          INSTRUMENT_ID: params.INSTRUMENT_ID,
          expand: `year,auditee.department`,
          all: `true`,
          year: params.YEAR,
          fields: [
            `year`,
            `auditee.department.DEPT_NAME`,
            `auditee.AUDITEE_ID`
          ].join(`,`),
        },
      }
    );

    setAuditees(response.data.items.map(item => {
      return {
        AUDITEE_ID : item.auditee.AUDITEE_ID,
        DEPT_NAME: item.auditee.department.DEPT_NAME,
      }
    }));
  }

  useEffect(() => {
    fetchInstruments();
    fetchReport();
  }, []);

  useEffect(() => {
    if (params?.INSTRUMENT_ID) {
      fetchYears();
    }
  }, [params?.INSTRUMENT_ID]);

  useEffect(() => {
    if (params?.YEAR) {
      fetchAuditees();
    }
  }, [params?.YEAR]);

  return (
    <Card>
      <Card.Header style={{ align: 'center', }}>
        <Card.Title as="h4">GRAFIK SEBARAN TEMUAN PER POIN KRITERIA</Card.Title>
        <div className="legend">
          {report && report.legends.map((legend, key) => (
            <span key={key}>
              <i className={`fas fa-circle mr-1 ${COLOR[key]}`}></i>
              {legend}{" "}
            </span>
          ))}
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
            <Col>
              <Form.Group>
                <Form.Label>Instruments</Form.Label>
                <Form.Control
                  defaultValue={3}
                  as="select"
                  value={params.INSTRUMENT_ID || -1}
                  onChange={({target:{value}}) => setParams({...params, INSTRUMENT_ID: value})}
                >
                  <option value={-1}>-- Please select instrument --</option>
                  {instruments && instruments.map((instrument, key) => (
                    <option key={key} value={instrument.INSTRUMENT_ID}>{instrument.INSTRUMENT_NAME}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Years</Form.Label>
                <Form.Control
                  as="select"
                  value={params.YEAR || ``}
                  onChange={({target:{value}}) => setParams({...params, YEAR: value})}
                >
                  <option value={``}>-- All year --</option>
                  {years && years.map((year, key) => (
                    <option key={key} value={year}>{year}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Auditees</Form.Label>
                <Form.Control
                  as="select"
                  value={params.AUDITEE_ID || ``}
                  onChange={({target:{value}}) => setParams({...params, AUDITEE_ID: value})}
                >
                 <option value={``}>-- All auditees --</option>
                 {auditees && auditees.map((auditee, key) => (
                   <option key={key} value={auditee.AUDITEE_ID}>{auditee.DEPT_NAME}</option>
                 ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Action.</Form.Label>
                <Form.Control
                  onClick={fetchReport}
                  as="button"
                  className="btn btn-primary"
                >
                  Generate
                </Form.Control>
              </Form.Group>
            </Col>
        </Row>
        <Row>
          <Col>
            {report && (
              <ChartistGraph
                data={{
                  labels: report.labels,
                  // series: report.series,
                  series: report.series.map((value, index) => {
                    console.log(index);
                    return {
                      value: value,
                      className: BAR_COLOR[index],
                    }
                  }),
                }}
                type="Bar"
                options={{
                  seriesBarDistance: 10,
                  axisX: {
                    showGrid: false,
                  },
                  stackBars: true,
                  height: "500px",
                  onlyInteger: true,
                  plugins: [
                    ChartistTooltip({
                      appendToBody: true
                    })
                  ]
                }}
                responsiveOptions={[
                  [
                    "screen and (max-width: 640px)",
                    {
                      seriesBarDistance: 5,
                      axisX: {
                        labelInterpolationFnc: function (value) {
                          return value[0];
                        },
                      },
                    },
                  ],
                ]}
              />
            )}
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer></Card.Footer>
    </Card>
  )
}